import { createSlice } from "@reduxjs/toolkit";
import { generateUniqueId } from "../../CommonMethods/CommonMethod";

const initialState = {
  alerts: [],
  isLoading: false,
};

export const AppSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    successAlert: (state, { payload }) => {
      if (state.alerts.length) {
        state.alerts.splice(0, 1);
      }
      state.alerts.push({
        message: payload.message,
        severity: "success",
        title: "Sucess",
        key: generateUniqueId(),
      });
    },
    errorAlert: (state, { payload }) => {
      if (state.alerts.length) {
        state.alerts.splice(0, 1);
      }
      state.alerts.push({
        message: payload.message,
        severity: "error",
        title: "Error",
        key: generateUniqueId(),
      });
    },
    removeAlert: (state) => {
      state.alerts.splice(0, 1);
    },
    loadingStarted: (state) => {
      state.isLoading = true;
    },
    loadingComplete: (state) => {
      state.isLoading = false;
    },
  },
});

export const {
  successAlert,
  errorAlert,
  removeAlert,
  loadingComplete,
  loadingStarted,
} = AppSlice.actions;

export default AppSlice.reducer;
